import { Component } from "@angular/core";
import { AlertController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";
import { Member } from "../../models/interfaces/member.model";
import { Payment } from "../../models/interfaces/payment.model";
import { PrivilegeRole } from "../../models/interfaces/privilegerole.model";
import { PaymentAddPage } from "../../pages/payment/payment_add";
import { PaymentViewPage } from "../../pages/payment/payment_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-payment",
  templateUrl: "payment.html",
})

export class PaymentPage {
  public static readonly PAYMENT_PY_ADD_ACCESS = "addPayment";
  public static readonly PAYMENT_PY_VIEW_ACCESS = "viewPayment";
  private exportViewName = "vw_export_payment";
  private exportFileName = "MemberShipPayment";
  private hasAddPaymentAccess: boolean = false;
  private hasViewPaymentAccess: boolean = false;
  private mbrFee = [];
  private show_status = [];
  private showLOA: boolean = false;
  private showRegular: boolean = true;
  private showResigned: boolean = false;
  private payment_by_status = [];
  private tmpSearchObject_by_status = [];
  private payment_tmp = [];
  private payment_tmp2 = [];
  private payment_LOA = [];
  private payment_Regular = [];
  private payment_Resigned = [];
  private payment = [];
  private paymenttype = [];
  private member$: any;
  private member: Member;
  private distinct_status = [];
  private styleName: string ="";
  private tmpSearchObject;
  private tmpSearchObject_LOA;
  private tmpSearchObject_Regular;
  private tmpSearchObject_Resigned;
  private zippedLOA: boolean = true;
  private zippedRegular: boolean = false;
  private zippedResigned: boolean = true;
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController, private db: DbserviceProvider,
  ) {
    console.log("PaymentPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    if (this.authService.currentUser) {
      this.hasAddPaymentAccess = this.db.hasAccess(PaymentPage.PAYMENT_PY_ADD_ACCESS);
      this.hasViewPaymentAccess = this.db.hasAccess(PaymentPage.PAYMENT_PY_VIEW_ACCESS);
    }
  }

  private ionViewWillEnter() {
    console.log("PaymentPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("PaymentPage onInitPage");

    this.db.dbCol({
      "action": "select", "mapObject": "vw_payment",
      "sqlExtended": " where st_id in (1,2,3)",
    }).subscribe((x) => {


      this.distinct_status = x.reduce((prev, { st_id, st_name }) =>
        prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name }], [])
      this.distinct_status.push()

      this.distinct_status.forEach((element, index, array) => {
        if (index == 0) {
          this.show_status[element.st_id] = true;
        }
        else {
          this.show_status[element.st_id] = false;
        }
        this.mbrFee[element.st_id] = element;
        this.tmpSearchObject_by_status[element.st_id]=this.payment_by_status[element.st_id];

        //this.payment_by_status[element.st_id] = x.filter(data => data.st_name == element.st_name);

      })

      

      this.distinct_status.forEach((st) => {

        // 1= LOA,2=Regular Member, 3=Resigned 
        this.payment_tmp2 = x.filter(data => data.st_id === st.st_id);
        this.payment_tmp2.forEach((element) => {
          if (this.payment_tmp[element.mb_hashname] === undefined) {
            this.payment_tmp[element.mb_hashname] = [];
          }
          this.payment_tmp[element.mb_hashname][element.pm_type + "id"] = element.py_id;
          this.payment_tmp[element.mb_hashname][element.pm_type] = element.py_amount;
          this.payment_tmp[element.mb_hashname].mb_photo = element.mb_photo;
          this.payment_tmp[element.mb_hashname].mb_status = element.st_name;
          this.payment_tmp[element.mb_hashname].py_id = element.py_id;
          this.payment_tmp[element.mb_hashname].mb_id = element.mb_id;
          this.payment_tmp[element.mb_hashname].co_id = element.co_id;
          this.payment_tmp[element.mb_hashname]["py_date" + element.pm_type] = element.py_date;
          this.payment_tmp[element.mb_hashname].pm_id = element.pm_id;
          this.payment_tmp[element.mb_hashname].py_amount = element.py_amount;
          this.payment_tmp[element.mb_hashname]["py_remark_" + element.pm_type] = element.py_remark;
          this.payment_tmp[element.mb_hashname].mb_hashname = element.mb_hashname;
        });
        // 1= LOA,2=Regular Member, 3=Resigned 

        this.payment_by_status[st.st_id]=this.payment_tmp;
        //console.error("this.payment_by_status", this.payment_by_status[st.st_id]);

        if (Number(st) === 1) {
          this.tmpSearchObject_LOA = this.payment_LOA = this.payment_tmp;
        } else if (Number(st) === 2) {
          this.tmpSearchObject_Regular = this.payment_Regular = this.payment_tmp;
        } else if (Number(st) === 3) {
          this.tmpSearchObject_Resigned = this.payment_Resigned = this.payment_tmp;
        }
        this.payment_tmp = [];
      })
    });

    this.db.dbCol({
      "action": "select", "mapObject": "payment_type",
      "sqlExtended": " order by payment_type.pm_order",
    }).subscribe((pt) => {
      this.paymenttype = pt;
    });
  }

  private ngOnDestroy() {
    console.log("PaymentPage ngOnDestroy");
  }

  private addPayment() {
    console.log("PaymentPage addPledge");
    this.navCtrl.push(PaymentAddPage);
  }

  private viewPayment(payment: Payment) {
    console.log("PaymentPage viewPledge");
    this.navCtrl.push(PaymentViewPage, {
      "payment": payment,
    });
  }

  private onClear(searchbar, status ) {
    console.log("PaymentPage clear");
    this.payment_by_status[status] = this.tmpSearchObject_by_status[status];
  }

  private search(searchbar, status) {
    console.log("PaymentPage searchbar");
    let q = searchbar.target.value;

    console.error("this.payment_by_status[status]",this.payment_by_status[status]);
    // reset any pre-filtered values
    this.payment_by_status[status] = this.tmpSearchObject_by_status[status];
    //let selected = [];

    if (q.trim() === "") {
      this.payment_by_status[status] = this.tmpSearchObject_by_status[status];
      return;
    }

    
    this.payment_by_status[status] = this.payment_by_status[status].filter((arrayEl) =>
      (arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_firstname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_lastname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_birthdate.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.st_name.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1),
    );
/*
    if (status_type === "Regular") {
      this.payment_Regular = this.tmpSearchObject_Regular;
      mb_status = this.payment_Regular;
    }
    else if (status_type === "Resigned") {
      this.payment_Resigned = this.tmpSearchObject_Resigned;
      mb_status = this.payment_Resigned;
    }
    else if (status_type === "LOA") {
      this.payment_LOA = this.tmpSearchObject_LOA;
      mb_status = this.payment_LOA;
    }*/


    /*Object.keys(mb_status).filter((key) => key.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1).map((i) => selected[i] = mb_status[i]);

    if (status_type === "Regular") {
      this.payment_Regular = selected;
    }
    else if (status_type === "Resigned") {
      this.payment_Resigned = selected;
    }
    else {
      this.payment_LOA = selected;
    }*/
  }

  private toggleStatus(currst: number) {
    console.log("PaymentPage toggleStatus");
    this.show_status[currst] = !this.show_status[currst];
  }

  private toggleLOA() {
    console.log("PaymentPage toggleLOA");
    if (this.showLOA === true) { this.showLOA = false; } else { this.showLOA = true; }
    this.zippedLOA = !this.zippedLOA;
  }
  private toggleRegular() {
    console.log("PaymentPage toggleRegular");
    if (this.showRegular === true) { this.showRegular = false; } else { this.showRegular = true; }
    this.zippedRegular = !this.zippedRegular;
  }
  private toggleResigned() {
    console.log("PaymentPage toggleResigned");
    if (this.showResigned === true) { this.showResigned = false; } else { this.showResigned = true; }
    this.zippedResigned = !this.zippedResigned;
  }
}



// WEBPACK FOOTER //
// ./src/pages/payment/payment.ts